import React, { useEffect, useState } from "react";

import RouteContainer from "./routes/RouteContainer";
import { GlobalContextProvider } from "./lib/context/GlobalContext/GlobalContextProvider";
import { useLocation } from "react-router-dom";

import "./App.scss";

function App() {
  const [appBackgroundColor, setAppBackgroundColor] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/infinite-50") {
      setAppBackgroundColor("white");
    } else if (location.pathname === "/infinite-110") {
      setAppBackgroundColor("#ccd2dd");
    } else {
      setAppBackgroundColor("black");
    }
  }, [location.pathname]);

  return (
    <div style={{ backgroundColor: appBackgroundColor }} className="App">
      <GlobalContextProvider>
        <RouteContainer />
      </GlobalContextProvider>
    </div>
  );
}

export default App;
